import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classNames from 'classnames';
import { EActiveTab } from '../../types/tabs';
import * as styles from './styles.css';
export var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs() {
    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (event, tab) {
      event.preventDefault();

      _this.props.changeTab(tab);
    });

    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeTab = _this$props.activeTab,
          returnUrl = _this$props.returnUrl;
      return /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, /*#__PURE__*/React.createElement("a", {
        className: classNames(styles['tab'], activeTab === EActiveTab.Authentication && styles['active']),
        href: "/authenticate/".concat(returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : ''),
        onClick: function onClick(event) {
          return _this2.handleTabClick(event, EActiveTab.Authentication);
        }
      }, "\u0412\u0445\u043E\u0434"), /*#__PURE__*/React.createElement("a", {
        className: classNames(styles['tab'], activeTab === EActiveTab.Registration && styles['active']),
        href: "/registration/".concat(returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : ''),
        onClick: function onClick(event) {
          return _this2.handleTabClick(event, EActiveTab.Registration);
        }
      }, "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F"));
    }
  }]);

  return Tabs;
}(React.Component);